import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#B7D436',
        secondary: '#f0b502',
        accent: '#6e2e9f',
        error: '#ff0000',
        info: '#5b9bd4',
        success: '#6fac46',
        warning: '#f6a000'
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
});

// HP Green #B7D436
// HP Dark Green #6fac46
// HP Red  #ff0000
// HP Yellow #f0b502
// HP Blue #5b9bd4
// HP Purple #6e2e9f
// HP Orange #f6a000
// HP Black #363532